import { useQuery } from "@apollo/react-hooks"
import CircularProgress from "@material-ui/core/CircularProgress"
import Menu from "@material-ui/core/Menu"
import MenuItem from "@material-ui/core/MenuItem"
import Button from "@material-ui/core/Button"
import gql from "graphql-tag"
import React, { Fragment, useContext, useMemo } from "react"
import { AppContext } from "Views/Home/context"
import { OpPerson } from "Types/op_person"
import cnchar from "cnchar"

const generateQuery = (tableName: string, isSpecies = false) => {
    return gql`
        query ${tableName} {
            ${tableName}(order_by: {id: asc} where: {is_species: {_eq: ${isSpecies}}}) {
                id
                name
                hidden
            }
        }
    `
}

const generateHealthQuery = (tableName: string) => {
    return gql`
        query ${tableName} {
            ${tableName}(order_by: {id: asc}) {
                id
                name
                hidden
            }
        }
    `
}

const ITEM_HEIGHT = 48
interface ComponentProps {
    tableName: string,
    onChange: (value: number) => void,
    opPerson: OpPerson,
    isSpecies: boolean
}
const OperationPerson = (props: ComponentProps) => {
    const { onChange, tableName, opPerson, isSpecies } = props
    const { op_person_id = 0 } = opPerson || {}
    const { user } = useContext(AppContext)
    const { role } = user || {}
    const { role_name } = role || {}
    const isTrueEditor = role_name === "true_editor"
    // const isSideEditor = role_name === "side_editor"
    // const isOpEditor = role_name === "op_editor"
    const query =  tableName === 'health_operation_person' ? generateHealthQuery(tableName) : generateQuery(tableName, isSpecies)
    const { data, loading } = useQuery(query, {
        fetchPolicy: "network-only",
    }) || {}
    const handleChange = (id: number) => {
        onChange(id)
        handleClose()
    }
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
    const dataMap = useMemo(() => {
        return data && data[tableName].reduce((acc: any, cur: any) => {
            acc[cur.id] = cur
            return acc
        }, {})
    }, [data, tableName])
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }
    if (loading) { return <CircularProgress size="small"/> }
    return (
        <div>
            {
                isTrueEditor ? (
                    <Fragment>
                        <Button onClick={handleClick}>
                            {dataMap[op_person_id] ? dataMap[op_person_id].name : "请选择"}
                        </Button>
                        <Menu
                            id="simple-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                            style={{
                                maxHeight: ITEM_HEIGHT * 10.5,
                            }}
                        >
                            {data[tableName].sort((a: any, b: any) => {
                                if (cnchar.isCnChar(a.name) && cnchar.isCnChar(b.name)) {
                                    // 汉字和汉字比
                                    return cnchar.compareSpell(a.name, b.name) === "more" ? 1 : -1
                                } else if (cnchar.isCnChar(a.name) || cnchar.isCnChar(b.name)) {
                                    // 汉字和英文比
                                    return cnchar.isCnChar(a.name) ? 1 : -1
                                } else {
                                    // 英文和英文比
                                    return a.name.localeCompare(b.name)
                                }
                            }).map((c: any) => {
                                return !c.hidden ? (
                                    <MenuItem onClick={() => handleChange(c.id)} value={c.id} key={c.id}>{c.name}</MenuItem>
                                ) : null
                            })}
                        </Menu>
                    </Fragment>
                ) :(
                    <Fragment>
                        <div>{dataMap[op_person_id] ? dataMap[op_person_id].name : "无值班"}</div>
                    </Fragment>
                )
            }
        </div>
    )
}

export default OperationPerson
